import { pushAuthHeaders, pushEndpointHost } from '../other/NotificationFunctions';

const postTripShare = async (endpoint, bookingId) => {
    try {
        const response = await fetch(`${pushEndpointHost()}/${endpoint}`, {
            method: 'POST',
            headers: await pushAuthHeaders(),
            body: JSON.stringify({ bookingId }),
        });
        const result = await response.json().catch(() => ({}));
        if (response.ok && result.success) return result;
        return { success: false, error: result.error || 'No se pudo completar. Intenta de nuevo.' };
    } catch (error) {
        return { success: false, error: 'No se pudo contactar al servidor. Revisa tu conexión e intenta de nuevo.' };
    }
};

/** Enlace público del viaje en curso: `{ success, url, code, expiresAt }`. */
export const createTripShare = (bookingId) => postTripShare('trip_share_create', bookingId);

export const revokeTripShare = (bookingId) => postTripShare('trip_share_revoke', bookingId);
